<template>
  <div>
    <h1 class="bd-title pageTitle" id="content">Quotes</h1>
    <loading-view v-if="loading" />
    <b-form @submit.stop.prevent>
      <b-container fluid>
        <b-form-group id="input" label="Search:" label-for="input-search">
          <b-form-row>
            <b-col lg="10" md="10" sm="12">
              <b-form-input
                id="input-search_string"
                v-on:keyup="onKeyPressed"
                v-model="input"
                placeholder="Enter Quote #, NSN, Part Number, ..."
                v-bind:autofocus="true"
              ></b-form-input>
            </b-col>
            <b-col lg="2" md="2" sm="12">
              <b-button 
                block
                variant="primary"
                v-on:click="onSearch"
                v-bind:disabled="loading"
              >Search
              </b-button>
            </b-col>
          </b-form-row>
        </b-form-group>
        <quote-summaries
          v-bind:response="quotes_response"
          v-bind:hasMore="has_more"
          v-on:loadMore="onLoadMore"
        />
      </b-container>
    </b-form>
  </div>
</template>

<script>
const PortalApi = require("@brightoncromwell/portal-api");
const quotesApiInstance = new PortalApi.QuotesApi();
let defaultClient = PortalApi.ApiClient.instance;

import QuoteSummaries from "@/components/quotes/QuoteSummaries";
import LoadingView from '@/components/common/LoadingView';
import { datadogLogs } from '@datadog/browser-logs';
import { getInstance } from '../../auth';

export default {
  name: "quotes",
  metaInfo: {
    title: "Quotes"
  },
  components: {
    "quote-summaries": QuoteSummaries,
    'loading-view': LoadingView
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      input: "",
      quotes_response: [],
      has_more: false,
      loading: false
    };
  },
  methods: {
    createResponse: function(quotes) {
      return quotes.items.map(item => ({
        id: item.id,
        label: item.label,
        receivedTs: item.receivedTs,
        opportunities: item.opportunities.map(opportunity => ({
          id: opportunity.id,
          label: opportunity.label,
          isActive: opportunity.isActive,
          openTs: opportunity.openTs,
          closeTs: opportunity.closeTs
        }))
      }));
    },
    getQuotes: async function() {
      const token = await this.getToken();
      let BearerAuth = defaultClient.authentications['BearerAuth'];
      BearerAuth.accessToken = token;

      this.loading = true;
      this.has_more = false;
      const opts = {
        offset: this.offset,
        limit: this.limit,
        search: this.input,
        companyId: localStorage.getItem('selected_company_id')
      };

      datadogLogs.logger.info('Getting Quote list', opts);

      quotesApiInstance.quotesGet(opts, (error, data, response) => {
        if (error) {
          console.error(error);
          if(error == "login_required"){
                  window.location.href = "/signin";
          }
          this.$emit('onError', response)
        } else {
          const quotes = this.createResponse(data);
          this.has_more = !(quotes.length < this.limit);
          this.quotes_response = this.quotes_response.concat(quotes);
        }
        this.loading = false;
      });
    }, 
    // $auth isn't loaded in by the time the page tries to get the token, so we need to do some extra steps in order to wait
    getToken: async function(){
      return new Promise((resolve, reject) => {
        const instance = getInstance();
        if(instance.loading == false){
          // Redirect if the user isn't authenticated
          if (!instance.isAuthenticated){
            window.location.href = "/signin";
          }
          resolve(instance.getTokenSilently());
        }
        else{
        instance.$watch("loading", loading => {
            if (loading == false && instance.isAuthenticated){
              
              instance
              .getTokenSilently()
              .then(authToken => { 
                resolve(authToken);
              })
              .catch(error => {
                if(error == "login_required"){
                  window.location.href = "/signin";
                }
                reject(error);
                });
            }
            // Redirect if the user isn't authenticated
            else if (!instance.isAuthenticated){
              window.location.href = "/signin";
            }
        });
        }
      });
    },
    onKeyPressed: function(e) {
      if (e.keyCode === 13) {
        this.onSearch();
      }
    },
    onSearch: function() {
      this.offset = 0;
      this.quotes_response = [];
      this.getQuotes();
    },
    onLoadMore: function() {
      this.offset = this.offset + this.limit;
      this.getQuotes();
    }
  },
  created() {
    this.onSearch();
  },
  mounted() {
    datadogLogs.logger.info('Quote List page displayed', {});
  }
};
</script>
